import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Switch } from '../../Components/Form';

const CommunicationPreferences = ({customer, updateCommunicationPreferences, isOpen, setIsOpen}) => {
    return <Modal title="Communication Preferences" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{customer, updateCommunicationPreferences}} />}
    </Modal>
}

const Inner = ({customer, updateCommunicationPreferences}) => {
    const data = customer.communicationPreferences || {
        transactional: true,
        promotional: true,
    };

    return <Form data={data} onSubmit={updateCommunicationPreferences} closeModalOnSubmit>

        <Switch name="transactional"
            label="Transactional messages"
            disabled={true}
            help="Customers must receive transactional messages."
        />
        <Switch name="promotional"
            label="Promotional messages"
            help="Customers who opt out of promotional messages will automatically be excluded from promotional broadcasts."
        />

        <Actions submit={{label: 'Update'}} cancel />
    </Form>
}


export default CommunicationPreferences;
